import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import Sidebar, { SidebarMenuButton } from "./Sidebar";
import { SIDEBAR_WIDTH } from "./sidebarConfig";
import TopBar from "./TopBar";
import { usePageTitle } from "./usePageTitle";
import ConfigStatusBanner from "../components/ConfigStatusBanner";

export default function MainLayout() {
  const title = usePageTitle();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Box
        component="a"
        href="#main-content"
        sx={{
          position: "absolute",
          left: -9999,
          top: "auto",
          width: 1,
          height: 1,
          overflow: "hidden",
          "&:focus": {
            position: "fixed",
            top: 8,
            left: 8,
            width: "auto",
            height: "auto",
            overflow: "visible",
            zIndex: (t) => t.zIndex.tooltip + 1,
            bgcolor: "primary.main",
            color: "primary.contrastText",
            px: 2,
            py: 1,
            borderRadius: 1,
            fontSize: "0.875rem",
            fontWeight: 600,
            textDecoration: "none",
          },
        }}
      >
        Skip to content
      </Box>
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <TopBar
        title={title}
        menuButton={
          <SidebarMenuButton onClick={() => setMobileOpen(true)} />
        }
      />
      <Box
        component="main"
        id="main-content"
        sx={{
          flexGrow: 1,
          width: isMobile ? "100%" : `calc(100% - ${SIDEBAR_WIDTH}px)`,
          p: 3,
        }}
      >
        <Toolbar />
        <ConfigStatusBanner />
        <Outlet />
      </Box>
    </Box>
  );
}
